import { render, staticRenderFns } from "./Exchanges.vue?vue&type=template&id=5b05b102&"
import script from "./Exchanges.vue?vue&type=script&lang=js&"
export * from "./Exchanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports